export const APPLY_TEXT = "common.apply";
